import { computed, ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { message } from 'ant-design-vue';
import { saveChannelMockConfigFetch } from '@/api/sandbox';
import { reportEvent, getNode } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'ChannelMockModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null,
    payChnlOptions: null
  },
  emits: ['update:modalVisible', 'refresh'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const isEdit = computed(() => {
      var _props$editItem;
      return !!((_props$editItem = props.editItem) !== null && _props$editItem !== void 0 && _props$editItem.id);
    });
    const visible = ref(false);
    const submitting = ref(false);
    const formRef = ref();
    const defaultForm = () => ({
      payChnl: undefined,
      orderNoField: '',
      mockSuccessBody: '',
      mockFailBody: ''
    });
    const formValue = ref(defaultForm());
    const rules = {
      payChnl: [{
        required: true,
        message: '请选择支付渠道',
        trigger: 'change'
      }],
      orderNoField: [{
        required: true,
        message: '请输入三方订单号字段',
        trigger: 'blur'
      }]
    };
    // 从后端 fieldMappings 里取 orderNo 映射的 sourcePath 回填单字段
    const extractOrderNoField = item => {
      var _item$fieldMappings, _m$sourcePath;
      const m = item === null || item === void 0 || (_item$fieldMappings = item.fieldMappings) === null || _item$fieldMappings === void 0 ? void 0 : _item$fieldMappings.find(it => it.targetField === 'orderNo');
      return (_m$sourcePath = m === null || m === void 0 ? void 0 : m.sourcePath) !== null && _m$sourcePath !== void 0 ? _m$sourcePath : '';
    };
    const handleOk = () => {
      var _formRef$value;
      (_formRef$value = formRef.value) === null || _formRef$value === void 0 || _formRef$value.validate().then(async () => {
        var _props$editItem$field, _props$editItem2, _props$editItem$statu, _props$editItem3, _props$editItem4;
        // 本页只暴露「三方订单号字段」(=orderNo 映射)，但后端 fieldMappings 可含
        // amount/currency/payMethod/thirdOrderNo 等其它映射；编辑时必须保留它们，
        // 否则整体替换数组会静默删除用户在别处配好的映射（数据丢失）。
        const otherMappings = ((_props$editItem$field = (_props$editItem2 = props.editItem) === null || _props$editItem2 === void 0 ? void 0 : _props$editItem2.fieldMappings) !== null && _props$editItem$field !== void 0 ? _props$editItem$field : []).filter(m => m.targetField !== 'orderNo');
        const params = {
          payChnl: formValue.value.payChnl,
          fieldMappings: [{
            sourcePath: formValue.value.orderNoField,
            targetField: 'orderNo',
            required: true
          }, ...otherMappings],
          // 直接传字符串（含空串）：后端 updateById 默认 NOT_NULL 策略会跳过 null 字段，
          // 传 undefined 会导致"清空报文"改不掉旧值，必须传 '' 才能真正清空
          mockSuccessBody: formValue.value.mockSuccessBody,
          mockFailBody: formValue.value.mockFailBody,
          // 本页不管理启停：编辑时沿用原状态，避免把库里已停用的配置静默改回启用；新增默认启用
          status: (_props$editItem$statu = (_props$editItem3 = props.editItem) === null || _props$editItem3 === void 0 ? void 0 : _props$editItem3.status) !== null && _props$editItem$statu !== void 0 ? _props$editItem$statu : 1
        };
        if ((_props$editItem4 = props.editItem) !== null && _props$editItem4 !== void 0 && _props$editItem4.id) {
          params.id = props.editItem.id;
        }
        try {
          submitting.value = true;
          const {
            code,
            msg
          } = await saveChannelMockConfigFetch(params);
          if (code === '0000') {
            message.success(isEdit.value ? '编辑成功' : '新增成功');
            emit('update:modalVisible', false);
            emit('refresh');
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '渠道mock配置',
                element_name: isEdit.value ? '编辑' : '新增'
              }
            });
          } else if (msg) {
            message.error(msg);
          }
        } catch (e) {} finally {
          submitting.value = false;
        }
      }).catch(e => void 0);
    };
    const closeModal = () => {
      var _formRef$value2;
      (_formRef$value2 = formRef.value) === null || _formRef$value2 === void 0 || _formRef$value2.clearValidate();
      emit('update:modalVisible', false);
    };
    watch(() => props.modalVisible, val => {
      visible.value = val;
      if (val) {
        var _formRef$value3, _props$editItem5;
        (_formRef$value3 = formRef.value) === null || _formRef$value3 === void 0 || _formRef$value3.clearValidate();
        if ((_props$editItem5 = props.editItem) !== null && _props$editItem5 !== void 0 && _props$editItem5.id) {
          var _props$editItem$mockS, _props$editItem$mockF;
          formValue.value = {
            payChnl: props.editItem.payChnl,
            orderNoField: extractOrderNoField(props.editItem),
            mockSuccessBody: (_props$editItem$mockS = props.editItem.mockSuccessBody) !== null && _props$editItem$mockS !== void 0 ? _props$editItem$mockS : '',
            mockFailBody: (_props$editItem$mockF = props.editItem.mockFailBody) !== null && _props$editItem$mockF !== void 0 ? _props$editItem$mockF : ''
          };
        } else {
          formValue.value = defaultForm();
        }
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[4] || (_cache[4] = $event => visible.value = $event),
        title: _unref(isEdit) ? '编辑渠道mock配置' : '新增渠道mock配置',
        width: "600px",
        "ok-text": "确定",
        "cancel-text": "取消",
        confirmLoading: submitting.value,
        centered: "",
        maskClosable: false,
        class: "channel-mock-modal",
        onOk: handleOk,
        onCancel: closeModal
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          class: "channel-mock-form",
          model: formValue.value,
          rules: rules,
          "label-col": {
            span: 6
          },
          "wrapper-col": {
            span: 17
          },
          "label-align": "right"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "支付渠道",
            name: "payChnl"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              value: formValue.value.payChnl,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.payChnl = $event),
              options: __props.payChnlOptions,
              disabled: _unref(isEdit),
              getPopupContainer: _unref(getNode),
              "show-search": "",
              "option-filter-prop": "label",
              placeholder: "请选择支付渠道"
            }, null, 8, ["value", "options", "disabled", "getPopupContainer"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "三方订单号字段",
            name: "orderNoField"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formValue.value.orderNoField,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formValue.value.orderNoField = $event),
              valueModifiers: {
                trim: true
              },
              allowClear: "",
              placeholder: "请输入三方订单号字段名，如 transaction_id"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "mock成功报文",
            name: "mockSuccessBody"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: formValue.value.mockSuccessBody,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.mockSuccessBody = $event),
              "auto-size": {
                minRows: 4,
                maxRows: 8
              },
              placeholder: "请输入mock成功报文（JSON字符串），如 {\"return_code\":\"SUCCESS\"}"
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "mock失败报文",
            name: "mockFailBody"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_textarea, {
              value: formValue.value.mockFailBody,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formValue.value.mockFailBody = $event),
              "auto-size": {
                minRows: 4,
                maxRows: 8
              },
              placeholder: "请输入mock失败报文（JSON字符串），如 {\"return_code\":\"FAIL\"}"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "title", "confirmLoading"]);
    };
  }
});